// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"d69b0a64","52":"b290c625","168":"d1d7c2bf","464":"5348394d","477":"76a40685","671":"b290c625","696":"f044735a","706":"db534513","727":"7a531475","824":"7a531475","828":"e1148d2f","984":"7a531475"}[chunkId] + ".chunk.css";
};